module.exports = "<p>\n  japanese works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/japanese/japanese.component.html
// module id = ../../../../../src/app/japanese/japanese.component.html
// module chunks = main